import { userStore } from '~/stores';
import { getCookieLang } from '~/utils/cookies';

export const getLangHeaders = (serverLang?: string) => ({
  headers: { 'x-lang': serverLang || getCookieLang() || userStore.lang || '' },
});
